import { formatDateBackend, parseDate } from "Backend";
import { CaseInfo } from "generated/graphql";

export type CaseInfoUI = Omit<CaseInfo, "dateOfBirth" | "dateOfDeath"> & {
  dateOfBirth?: Date;
  dateOfDeath?: Date;
};

export function caseInfoFromUI(caseInfoUI: CaseInfoUI): CaseInfo {
  return {
    ...caseInfoUI,
    dateOfBirth: formatDateBackend(caseInfoUI.dateOfBirth) || null,
    dateOfDeath: formatDateBackend(caseInfoUI.dateOfDeath) || null,
  };
}

export function caseInfoToUI(caseInfo: CaseInfo): CaseInfoUI {
  return {
    ...caseInfo,
    dateOfBirth: parseDate(caseInfo.dateOfBirth),
    dateOfDeath: parseDate(caseInfo.dateOfDeath),
  };
}
